import React from 'react'
import {AppBar,Toolbar,IconButton,Badge,MenuItem,Menu,Typography} from '@material-ui/core';
import {ShoppingCart} from '@material-ui/icons'
import useStyles from './styles'
import logo from '../../assets/apple-touch-icon.png'
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({totalItems}) => {
    const classes= useStyles();
    const location = useLocation();

    

    return (
        <>
         <AppBar position='fixed' className={classes.AppBar} color='inherit'>
             <Toolbar>
                <Typography component={Link} to="/ecommerce-react" varient='h6' className={classes.title} color='inherit'>
                    <img src={logo} alt="FarmHouse" height="25px" className={classes.image}/>
                    FarmHouse
                </Typography>
                <div className={classes.grow}/>
                {location.pathname === '/ecommerce-react/' && (
                    <div className={classes.button}>
                    <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
                        <Badge badgeContent={totalItems } color="secondary">
                            <ShoppingCart/>
                        </Badge>
                    </IconButton>
                    </div>
                    )}
            </Toolbar>

             </AppBar>   
        </>
    )
}

export default Navbar
